import React, { useMemo } from 'react';
import Productos from "./TiposCategoria";
import VinosLista from "./VinosLista";
import style from "./Carta.module.css";

const ProductsSection = ({ 
  categorias,
  categoriasSinProductos,
  getID,
  categoriaID,
  mostrarVinos,
  sectionRefs,
  preloadedProducts,
  onProductoClick,
  registrarCategoriaSinProductos,
  cargando
}) => {
  const categoriasFiltradas = useMemo(() => {
    return categorias.filter(categoria => !categoriasSinProductos.has(getID(categoria)));
  }, [categorias, categoriasSinProductos, getID]);

  if (cargando) {
    return (
      <div className={style.loading_message}>Cargando...</div>
    );
  }

  return (
    <div>
      {categoriasFiltradas.map((categoria) => {
        const categoriaId = getID(categoria);
        const preloadedData = preloadedProducts[categoriaId];
        
        return (
          <div 
            key={categoriaId} 
            ref={sectionRefs.current[categoriaId]}
            className={style.seccion_categoria}
            data-category-id={categoriaId}
          >
            <h2 className={style.categoria_tab}>{categoria.nombre}</h2>
            <div className="sentinel"></div>
            
            {mostrarVinos ? (
              <VinosLista 
                tipoCategoria={categoriaId} 
                onVinoClick={onProductoClick}
                onSinProductos={() => registrarCategoriaSinProductos(categoriaId)}
                loadFavoritos={categoriaID === categoriaId} 
              />
            ) : (
              <Productos 
                tipoCategoria={categoriaId} 
                onProductoClick={onProductoClick}
                onSinProductos={() => registrarCategoriaSinProductos(categoriaId)}
                loadFavoritos={categoriaID === categoriaId}
                preloadedData={preloadedData}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ProductsSection;